import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import Header from '../components/Header';

export default function PaymentCancel() {
  useEffect(() => { document.title = 'Checkout cancelled — Trades & Neighbours'; }, []);
  return (
    <div className="min-h-screen bg-[#FAF9F6]" data-testid="payment-cancel-page">
      <Header />
      <div className="mx-auto max-w-2xl px-6 py-24 md:px-10">
        <div className="border border-[#E5E4E0] bg-white p-10">
          <XCircle className="text-[#8A8988]" size={30} />
          <h1 className="mt-6 font-heading text-3xl font-bold text-[#1C1B1A]">Checkout cancelled</h1>
          <p className="mt-3 text-[#5C5B5A]">No charge was made. Your account is exactly as you left it.</p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/agency/pricing" className="btn-primary" data-testid="back-to-plans-btn">See plans again</Link>
            <Link to="/" className="border border-[#1C1B1A] px-5 py-3 text-sm font-semibold text-[#1C1B1A] transition-colors hover:bg-[#1C1B1A] hover:text-white" data-testid="back-home-btn">
              Back home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
